var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.badge)?_c('span',{staticClass:"text-caption ml-1"},[_vm._v("· "+_vm._s(_vm.badge))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }